import { render, staticRenderFns } from "./UserEmergency.vue?vue&type=template&id=25ca4c77&"
import script from "./UserEmergency.vue?vue&type=script&lang=js&"
export * from "./UserEmergency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports